'use client';;!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:tillamook-com":true});}catch(e){}}();

import React, { useEffect, useRef, useState } from 'react';

import { disableBodyScroll, enableBodyScroll } from 'body-scroll-lock';
import cx from 'clsx';

import Button from 'components/ui/Button';
import ButtonCTA from 'components/ui/ButtonCTA';
import Img from 'components/ui/Img';
import SvgIcon from 'components/ui/SvgIcon';
import Text from 'components/ui/Text';

import TalesBlockHeader from './TalesOverlayBlocks/TalesBlockHeader';
import TalesBlockImageFull from './TalesOverlayBlocks/TalesBlockImageFull';
import TalesBlockImageLeft from './TalesOverlayBlocks/TalesBlockImageLeft';
import TalesBlockIntro from './TalesOverlayBlocks/TalesBlockIntro';
import TalesBlockParagraph from './TalesOverlayBlocks/TalesBlockParagraph';
import TalesBlockTwoImage from './TalesOverlayBlocks/TalesBlockTwoImage';
import TalesBlockTwoImageCycle from './TalesOverlayBlocks/TalesBlockTwoImageCycle';

import EyebrowRibbon from '../EyebrowRibbon';

import styles from './TalesOverlay.module.scss';

const blockMap = {
    ImageFull: TalesBlockImageFull,
    ImageLeft: TalesBlockImageLeft,
    Intro: TalesBlockIntro,
    TwoImage: TalesBlockTwoImage,
    Paragraph: TalesBlockParagraph,
    ImageTwo: TalesBlockTwoImage,
    ImageTwoCycle: TalesBlockTwoImageCycle,
};

const TalesOverlay = ({
    content,
    isActive,
    id,
    onClose,
    overlayChapters,
    onSetChapterId,
    onActiveChapterSelect,
    onAnchorClick,
}) => {
    const overlayRef = useRef(null);
    const [isOverlayNavUse, setIsOverlayNavUse] = useState(false);

    const otherChapters = overlayChapters?.filter(chapter => chapter.id !== id);

    useEffect(() => {
        if (isActive && id && overlayChapters) {
            onActiveChapterSelect && onActiveChapterSelect(id);
        }
    }, [isActive, id, overlayChapters, onActiveChapterSelect]);

    useEffect(() => {
        let timer;
        if (!isActive && overlayRef.current) {
            timer = setTimeout(() => {
                overlayRef.current.scrollTo({ top: 0, behavior: 'smooth' });
            }, 600);
        }
        return () => {
            clearTimeout(timer);
        };
    }, [isActive]);

    useEffect(() => {
        if (isActive) {
            disableBodyScroll(overlayRef.current);
        } else {
            enableBodyScroll(overlayRef.current);
        }
    }, [isActive]);

    const handleNavClick = id => {
        setIsOverlayNavUse(true);
        onSetChapterId(id);
    };

    const handleClose = () => {
        setIsOverlayNavUse(false);
        onClose();
    };

    return (
        <section
            className={cx(styles.root, {
                [styles.isActive]: isActive,
                [styles.isOverlayNavUse]: isOverlayNavUse,
            })}
        >
            <div ref={overlayRef} className={styles.overflow}>
                <div
                    className={styles.inner}
                    style={{
                        backgroundColor: `var(--tales-color-${content.color})`,
                    }}
                >
                    <div className={styles.blocks}>
                        <TalesBlockHeader
                            eyebrow={content.eyebrow}
                            headline={content.title}
                            isActive={isActive}
                        />
                        {content?.blocks?.map((block, index) => {
                            const BlockComponent = blockMap[block.type];
                            return BlockComponent ? (
                                <BlockComponent
                                    key={index}
                                    {...block}
                                    isActive={isActive}
                                    onAnchorClick={onAnchorClick}
                                />
                            ) : null;
                        })}
                        {!overlayChapters && (
                            <div className={styles.footer}>
                                <ButtonCTA
                                    className={styles.closeFooter}
                                    style="filled-blue-ocean"
                                    onClick={handleClose}
                                    text={'Close'}
                                    iconType="closeSmall"
                                />
                            </div>
                        )}
                    </div>
                    {overlayChapters && id && (
                        <nav className={styles.nav}>
                            <div className={styles.navHeader}>
                                <Text
                                    className={styles.navHeadline}
                                    baseTheme="displayXXSmall"
                                >
                                    more to explore
                                </Text>
                            </div>
                            <ul className={styles.navItems}>
                                {otherChapters.map(chapter => (
                                    <li key={chapter.id}>
                                        <Button
                                            className={styles.navItem}
                                            theme="none"
                                            onClick={() =>
                                                handleNavClick(chapter.id)
                                            }
                                        >
                                            <span
                                                className={styles.navItemInner}
                                                style={{
                                                    backgroundColor: `var(--tales-color-${chapter.color})`,
                                                }}
                                            >
                                                <div
                                                    className={
                                                        styles.navItemLockup
                                                    }
                                                >
                                                    <EyebrowRibbon>
                                                        {chapter.years}
                                                    </EyebrowRibbon>
                                                    <Text
                                                        className={
                                                            styles.navItemTitle
                                                        }
                                                        baseTheme="displayXXSmall"
                                                    >
                                                        <span
                                                            dangerouslySetInnerHTML={{
                                                                __html: chapter.title,
                                                            }}
                                                        />
                                                    </Text>
                                                </div>
                                                <Img
                                                    className={
                                                        styles.navItemImage
                                                    }
                                                    src={chapter.navImage.url}
                                                    width={
                                                        chapter.navImage?.width
                                                    }
                                                    height={
                                                        chapter.navImage?.height
                                                    }
                                                    alt={
                                                        chapter.navImage
                                                            .description
                                                    }
                                                    customSources={[
                                                        {
                                                            breakpoint: 768,
                                                            src: chapter
                                                                .navImageLarge
                                                                .url,
                                                            imageWidth: 1280,
                                                        },
                                                        {
                                                            src: chapter
                                                                .navImage.url,
                                                            imageWidth: 500,
                                                        },
                                                    ]}
                                                />
                                            </span>
                                        </Button>
                                    </li>
                                ))}
                            </ul>
                        </nav>
                    )}
                </div>
                <Button
                    className={styles.close}
                    theme="close"
                    onClick={handleClose}
                >
                    <SvgIcon type="close" />
                    <span className="sr-only">
                        Close the overlay for {content.title}
                    </span>
                </Button>
            </div>
        </section>
    );
};

export default TalesOverlay;
